import {format} from 'date-fns'


export default function (date) {
    console.log('format date')
    if (!date)
        return ''
    return format(date, 'yyyy-MM-dd')
}